<div class="modal fade show" style="display: block; background-color: rgba(0, 0, 0, 0.5); z-index: 1000">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content w-auto rounded-16 overflow-hidden border-0">
      <div class="modal-body p-0">
        <div class="text-center">
          <img src="/assets/images/banner-modelo700500.png" class="img-fluid" alt="Banner Modelo" />
        </div>

        <div class="modal-footer">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div>
              <mat-checkbox [(ngModel)]="aceite" id="termoFidelidade"></mat-checkbox>
              <label class="form-check-label" for="termoFidelidade">
                Li e estou de acordo com os
                <a href="javascript:void(0);" (click)="openTermosDeServico()">termos dos serviços</a> da {{ site }}
              </label>
            </div>
            <button type="button" mat-flat-button (click)="submitForm()">Avançar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
